import React from 'react';
import styles from './index.module.less';
import Image from 'next/image';

const Index: React.FC<any> = ({ content }) => {
  const showContent = content.contentInfo['section-search-works'];
  if (!showContent.title) {
    return null;
  }
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{showContent.title}</h2>
      <p className={styles.desc}>{showContent.desc}</p>
      <ul className={styles.list}>
        {showContent.cards.map((item: any) => (
          <li key={item.title}>
            <h3 className={styles.itemTitle}>{item.title}</h3>
            <div className={styles.itemContent}>{item.desc}</div>
            <Image src={item.imgPath} alt={item.title} width={400} height={100} className={styles.imgPath} />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Index;
